module.exports = __webpack_public_path__ + "static/img/OSCAR-WILLIS.7c1629a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OSCAR-WILLIS.jpg
// module id = 9OJz
// module chunks = 0